import type { AuthVisibility } from '../sanity-typegen';

export const pageUrlTypes = ['page', 'staticPageContact', 'staticPageRegistration'] as const;
export const urlTypes = [...pageUrlTypes, 'external', 'policy', 'blogArticle', 'blogListing'] as const;

export type PageUrlType = (typeof pageUrlTypes)[number];
export type UrlType = (typeof urlTypes)[number];

export type SanityLinkFragment = {
  _key: string;
  authVisibility: AuthVisibility;
  id?: string;
  label: string;
  url: string;
  urlType: UrlType;
};
